import React from 'react';
import {countFilterUniqueAttrs} from 'Components/flowChart/utils';
import {INodePreviewProps} from '../../types';
import {IMetadata} from './types';
import {CardBlock, CardText} from '../styled';

export type INodeWFRNodeProps = INodePreviewProps<IMetadata>;

export const NodeWFRNodePreview: React.FC<INodeWFRNodeProps> = (props) => {
	const {node} = props;

	const filters = node?.metadata?.filters;

	if (!filters) {
		return null;
	}

	const numAttributes = countFilterUniqueAttrs(filters);

	return (
		<CardBlock>
			<CardText>Condition:</CardText>
			<CardText>{`Have ${numAttributes} attribute(s)`}</CardText>
		</CardBlock>
	);
};
